import { render, staticRenderFns } from "./SupiTableMenu.vue?vue&type=template&id=080b1c1c&scoped=true&"
import script from "./SupiTableMenu.vue?vue&type=script&lang=js&"
export * from "./SupiTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b1c1c",
  null
  
)

export default component.exports